/**
 * ErzieherWissen Product AJAX Cart
 *
 * Verhindert auf Produktseiten die Weiterleitung zur Warenkorb-Seite,
 * legt das Produkt per AJAX in den Warenkorb und zeigt stattdessen
 * eine kurze Toast-Meldung am unteren Bildschirmrand.
 *
 * Einbindung in Shopify:
 * {{ 'erzieherwissen-custom.js' | asset_url | script_tag }}
 */
(function () {
  var toastTimer = null;

  // Erstellt den Toast nur einmal und verwendet ihn danach wieder.
  function ensureToast() {
    var existingToast = document.getElementById('ew-product-cart-toast');
    if (existingToast) return existingToast;

    var toast = document.createElement('div');
    toast.id = 'ew-product-cart-toast';
    toast.className = 'ew-product-cart-toast';
    toast.setAttribute('role', 'status');
    toast.setAttribute('aria-live', 'polite');
    toast.innerHTML =
      '<svg class="ew-product-cart-toast__icon" viewBox="0 0 24 24" fill="none" stroke="#ffd95a" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
      '<polyline points="20 6 9 17 4 12"></polyline>' +
      '</svg>' +
      '<span>Zum Warenkorb hinzugefügt&nbsp;&middot;&nbsp;<a href="/cart">Warenkorb ansehen</a></span>';

    document.body.appendChild(toast);
    return toast;
  }

  // Hängt die Toast-Styles per JS an, damit keine separate CSS-Datei nötig ist.
  function ensureStyles() {
    if (document.getElementById('ew-product-cart-toast-style')) return;

    var style = document.createElement('style');
    style.id = 'ew-product-cart-toast-style';
    style.textContent =
      '.ew-product-cart-toast{' +
      'position:fixed;' +
      'bottom:22px;' +
      'left:50%;' +
      'transform:translate(-50%,16px);' +
      'z-index:9999;' +
      'display:flex;' +
      'align-items:center;' +
      'gap:8px;' +
      'max-width:calc(100vw - 32px);' +
      'padding:12px 20px;' +
      'border-radius:14px;' +
      'background:#27353a;' +
      'color:#fff;' +
      'box-shadow:0 12px 30px rgba(0,0,0,.25);' +
      'font-family:Fredoka,Poppins,Segoe UI,sans-serif;' +
      'font-size:14px;' +
      'font-weight:600;' +
      'line-height:1.25;' +
      'opacity:0;' +
      'pointer-events:none;' +
      'transition:opacity .25s ease,transform .25s ease;' +
      '}' +
      '.ew-product-cart-toast a{' +
      'color:#ffd95a;' +
      'text-decoration:underline;' +
      '}' +
      '.ew-product-cart-toast__icon{' +
      'width:16px;' +
      'height:16px;' +
      'flex-shrink:0;' +
      '}' +
      '.ew-product-cart-toast.is-visible{' +
      'opacity:1;' +
      'transform:translate(-50%,0);' +
      'pointer-events:auto;' +
      '}' +
      '@media (prefers-reduced-motion:reduce){' +
      '.ew-product-cart-toast{transition:none;}' +
      '}';

    document.head.appendChild(style);
  }

  // Zeigt den Toast an und blendet ihn nach kurzer Zeit wieder aus.
  function showToast() {
    ensureStyles();

    var toast = ensureToast();
    clearTimeout(toastTimer);
    toast.classList.add('is-visible');

    toastTimer = setTimeout(function () {
      toast.classList.remove('is-visible');
    }, 3500);
  }

  // Aktualisiert gängige Warenkorb-Zähler-Selektoren, z. B. im Dawn-Header.
  function updateCartCount(itemCount) {
    [
      '.cart-count-bubble span[aria-hidden="true"]',
      '.cart-count-bubble span:not(.visually-hidden)',
      '[data-cart-count]',
      '.cart-count'
    ].forEach(function (selector) {
      document.querySelectorAll(selector).forEach(function (element) {
        element.textContent = itemCount;
      });
    });

    document.querySelectorAll('.cart-count-bubble').forEach(function (bubble) {
      bubble.style.display = itemCount > 0 ? '' : 'none';
    });
  }

  // Beschränkt den Handler auf echte Produktformulare mit Warenkorb-Button.
  function isProductAddForm(form) {
    if (!form) return false;
    if (!form.querySelector('.product-form__submit')) return false;

    var action = form.getAttribute('action') || '';
    return action.indexOf('/cart/add') !== -1 || form.querySelector('[name="id"]');
  }

  // Capturing-Phase, damit die Theme-eigene Submit-Logik nicht vorher weiterleitet.
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!isProductAddForm(form)) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    var button = form.querySelector('.product-form__submit');
    if (button) {
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
    }

    // Produkt in den Warenkorb legen, ohne die Seite zu verlassen.
    fetch('/cart/add.js', {
      method: 'POST',
      body: new FormData(form),
      headers: {
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      }
    })
      .then(function (response) {
        if (!response.ok) throw new Error('add failed');
        return response.json();
      })
      .then(function () {
        showToast();

        // Danach den Warenkorb abrufen, damit der Header-Zähler aktuell bleibt.
        return fetch('/cart.js', {
          headers: {
            'Accept': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          }
        });
      })
      .then(function (response) {
        if (!response.ok) throw new Error('cart failed');
        return response.json();
      })
      .then(function (cart) {
        updateCartCount(cart.item_count);
      })
      .catch(function (error) {
        // Keine automatische Weiterleitung als Fallback, weil die Seite stehen bleiben soll.
        console.error('Cart error:', error);
      })
      .finally(function () {
        if (button) {
          button.disabled = false;
          button.removeAttribute('aria-busy');
        }
      });
  }, true);
})();
